import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="container-app py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-slate-900 mb-8">Terms & Conditions</h1>
          
          <div className="bg-white rounded-2xl p-8 border border-slate-200 prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing or using LegalHub, you agree to be bound by these Terms & Conditions. 
              If you do not agree with any part of these terms, you may not use our platform.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">2. Platform Description</h2>
            <p className="text-slate-600 mb-4">
              LegalHub is an online platform that connects clients seeking legal services with 
              independent lawyers. We are NOT a law firm and do not provide legal advice directly.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">3. User Accounts</h2>
            <p className="text-slate-600 mb-4">
              Users must provide accurate and complete information during registration. You are 
              responsible for maintaining the confidentiality of your account credentials.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">4. Lawyer Verification</h2>
            <p className="text-slate-600 mb-4">
              All lawyers on our platform undergo verification including Bar Council registration 
              verification. However, users should exercise their own judgment when selecting a lawyer.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">5. Payments & Refunds</h2>
            <p className="text-slate-600 mb-4">
              All payments are processed through secure payment gateways. Consultation fees are 
              non-refundable once the consultation has been completed. Cancellation within 24 hours 
              of booking may be eligible for a full refund.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              LegalHub is not liable for any legal outcomes resulting from consultations arranged 
              through our platform. We do not guarantee any specific results from legal consultations.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">7. Disclaimer</h2>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-200 mb-4">
              <p className="text-amber-800">
                <strong>IMPORTANT:</strong> LegalHub is a platform for connecting clients with lawyers. 
                We are NOT a law firm and do NOT provide legal advice. Any information on this platform 
                should not be construed as legal advice. The outcome of legal matters depends on various 
                factors and cannot be guaranteed.
              </p>
            </div>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">8. Governing Law</h2>
            <p className="text-slate-600 mb-4">
              These terms shall be governed by and construed in accordance with the laws of India. 
              Any disputes arising shall be subject to the exclusive jurisdiction of courts in India.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">9. Contact</h2>
            <p className="text-slate-600">
              For any questions regarding these terms, please contact us at support@legalhub.com
            </p>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="text-amber-600 hover:text-amber-700 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
